export const darkTheme = {
  primary: '#3BC0B7',
  primaryLight: '#5dd4cc',
  primaryDark: '#2a9d95',
  secondary: '#34495E',
  textPrimary: '#ECF0F1',
  textSecondary: '#B0BEC5',
  background: '#181E24',
  backgroundPaper: '#1E2A35',
  success: '#4D9C7E',
  error: '#E74C3C',
  errorDark: '#C0392B',
  info: '#3498DB',
  warning: '#F1C40F',

  divider: 'rgba(255, 255, 255, 0.08)',
  textMuted: '#95A5A6',
  rowEven: '#1E2A35',
  rowOdd: 'transparent',
  rowComplete: '#34495E',
  textButton: '#FFFFFF',
  cardHover: 'rgba(59, 192, 183, 0.06)',
  inputBorder: 'rgba(255, 255, 255, 0.12)',
  sidebarBg: '#1E2A35',
  chartColors: ['#3BC0B7', '#34495E', '#FFCE56', '#4BC0C0', '#9966FF', '#FF9F40'],
};
